import Keycloak from "keycloak-js";
import config from "../config/index";

const KEY_CLOAK_URL = config.keycloak.url;
const CLIENT_ID = config.keycloak.clientId;
const REALM = config.keycloak.realm;

let initOptions = {
  url: KEY_CLOAK_URL,
  realm: REALM,
  clientId: CLIENT_ID,
};

export const keycloak = new Keycloak(initOptions);
/******************* Key cloak loggers and functions******************* */

const getUserInfo = async () => {
  try {
    const userData = await keycloak.loadUserInfo();
    return userData;
  } catch (error) {
    console.log(error);
    return undefined;
  }
};
export { getUserInfo };
let isTokenLogged = false;
export const tokenLogger = async (tokenData) => {
  if (tokenData.token && !isTokenLogged) {
    window.localStorage.setItem("userToken", tokenData.token);
    const data = await keycloak.loadUserInfo();
    window.localStorage.setItem("userRole", keycloak.realmAccess.roles);
    window.localStorage.setItem("userEmail", data.email);
    window.localStorage.setItem("userId", data.sub);
    window.localStorage.setItem("currentUserName", data.name);
  }
};

export const eventLogger = async (event) => {
  if (event === "onAuthLogout") {
    window.location.href = config.unifiedPageUrl;
  }
};
export const logoutUser = async () => {
  await keycloak.logout();
};
